import { Component, OnInit } from "@angular/core";
import * as wjGrid from "wijmo/wijmo.grid";
import * as wjCore from "wijmo/wijmo";
import { ConvertIsoDateService } from "@app/modules/shared/services/convert-iso-date.service";
import { ToastService } from "@app/modules/shared/services/message/toast.service";
import { KlLoadingService } from "@app/modules/shared/services/kl-loading.service";
import { KlAlertService } from "@app/modules/shared/services/message/alert.service";
import { ApiService } from "@app/modules/shared/services/base/api.service";
import { UtilService } from "@app/modules/shared/services/util.service";

@Component({
  selector: "kl-currency",
  templateUrl: "./currency.component.html",
  styleUrls: ["./currency.component.scss"],
})
export class CurrencyComponent implements OnInit {
  today: any;
  yesterday: any;
  loading: boolean;
  collectionView: wjCore.CollectionView;
  collectionSource: any;
  disabledButton: boolean;

  alertShow: boolean;
  alertType: string;
  alertMessage: string;

  constructor(
    private alertService: KlAlertService,
    private apiService: ApiService,
    private utilService: UtilService,
    private dateConvert: ConvertIsoDateService,
    private klLoadingService: KlLoadingService,
    private toaster: ToastService
  ) {}

  ngOnInit() {
    this.today = new Date();
    this.filter(this.dateConvert.convertDate(this.today));
  }

  updateCurrency() {
    this.klLoadingService.show("loading");
    this.apiService
      .updateData(
        "currency/" + this.dateConvert.convertDate(this.today),
        this.collectionView.sourceCollection
      )
      .subscribe(
        (resUpdate) => {
          this.klLoadingService.hide();
          this.toaster.toastSuccess();
          this.collectionSource = resUpdate;
          this.collectionView = new wjCore.CollectionView(
            this.collectionSource
          );
        },
        (errUpdate) => this.handleError(errUpdate)
      );
  }

  calendarSelect(event) {
    this.today = event;
    this.filter(this.dateConvert.convertDate(event));
  }

  changeDates(action) {
    switch (action) {
      case "forward":
        this.today = new Date(this.today.getTime() + 86400000);
        break;
      case "backward":
        this.today = new Date(this.today.getTime() - 86400000);
        break;
    }
    this.filter(this.dateConvert.convertDate(this.today));
  }

  getCurrency(type) {
    this.klLoadingService.show("loading");
    switch (type) {
      case "tcmb":
        const todayDate = this.dateConvert.convertDate(this.today);
        this.apiService.getAllData("exchangeUpdate/" + todayDate).subscribe(
          (resExchange) => {
            this.collectionSource = resExchange;
            for (let i = 0; i < resExchange.length; i++) {
              if (resExchange[i].currency_exchange_rates.length === 0) {
                this.collectionSource[i].currency_exchange_rates = [
                  {
                    purchase_amount: 0.0,
                    sales_amount: 0.0,
                    effective_purchase_amount: 0.0,
                    effective_sales_amount: 0.0,
                  },
                ];
              }
              this.collectionSource[i].currency_exchange_rates[0].date =
                this.today.getTime();
            }
            this.klLoadingService.hide();
            this.collectionView = new wjCore.CollectionView(
              this.collectionSource
            );
          },
          (errExchange) => this.handleError(errExchange)
        );
        break;
      case "yesterday":
        this.yesterday = new Date(this.today.getTime() - 86400000);
        const date = this.dateConvert.convertDate(this.yesterday);
        this.apiService.getFilterDataByDate("currency/rate", date).subscribe(
          (response) => {
            for (let i = 0; i < response.length; i++) {
              response[i].currency_exchange_rates[0].id =
                this.collectionSource[i].currency_exchange_rates[0].id;
              this.collectionSource[i].currency_exchange_rates[0] =
                response[i].currency_exchange_rates[0];
              this.collectionSource[i].currency_exchange_rates[0].date =
                this.today.getTime();
            }
            this.klLoadingService.hide();
            this.collectionView = new wjCore.CollectionView(
              this.collectionSource
            );
          },
          (err) => this.handleError(err)
        );
        break;
    }
  }

  filter(date: any) {
    this.klLoadingService.show("loading");
    this.apiService.getFilterDataByDate("currency/rate", date).subscribe(
      (response) => {
        this.collectionSource = response;
        for (let i = 0; i < response.length; i++) {
          if (response[i].currency_exchange_rates.length === 0) {
            this.collectionSource[i].currency_exchange_rates = [
              {
                date: this.today.getTime(),
                purchase_amount: 0.0,
                sales_amount: 0.0,
                effective_purchase_amount: 0.0,
                effective_sales_amount: 0.0,
              },
            ];
          }
        }
        this.klLoadingService.hide();
        this.collectionView = new wjCore.CollectionView(this.collectionSource);
      },
      (err) => this.handleError(err)
    );
  }

  onFlexKeyPress(flexGrid: wjGrid.FlexGrid, event: any) {
    const keyCode = window.event ? event.which : event.keyCode;
    if (keyCode === 9) {
      if (flexGrid.selection.col === flexGrid.columns.length - 1) {
        if (flexGrid.selection.row === flexGrid.rows.length - 1) {
          return true;
        }
        let i = 0;
        while (flexGrid.columns[i].isReadOnly) {
          i++;
        }
        flexGrid.select(new wjGrid.CellRange(flexGrid.selection.row + 1, i));
      } else {
        let i = flexGrid.selection.col + 1;
        while (flexGrid.columns[i].isReadOnly) {
          i++;
        }
        flexGrid.select(new wjGrid.CellRange(flexGrid.selection.row, i));
      }
      return false;
    }
  }

  handleError(error) {
    this.alertShow = true;
    this.alertType = "error";
    this.alertMessage = this.utilService.alertErrorMessage(error);
    this.klLoadingService.hide();
  }
}
